import { useConfirmationDialog } from '@openx/components-core/lib/Dialog/ConfirmationDialog/useConfirmationDialog.tsx';
import { useCallback } from 'react';
import { DealActivationModalContent } from './DealActivationModalContent.tsx';

export function useDealActivationModal() {
  const { open } = useConfirmationDialog();

  const openDealActivationModal = useCallback(
    (dealName: string): void => {
      open({
        cancelLabel: 'Close',
        confirmationDisabled: true,
        content: <DealActivationModalContent dealName={dealName} />,
        customContent: true,
        hideConfirm: true,
        showExtraBtn: false,
        title: 'Deal Activation',
      });
    },
    [open]
  );

  return { openDealActivationModal };
}
